module.exports = __webpack_public_path__ + "static/media/guilt-large.a43e5553.png";